import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { SubscriptionState } from './types'
import { RootState } from '../types'

export const state: SubscriptionState = {
  subscriptions:{
    things:{
      updated:[]
    }
  }
}

const namespaced: boolean = true

export const subscriptionState: Module<SubscriptionState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
